import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PermissionForStudents } from '@edtech-ui/access-role-permissions/users-permissions-constants/student-roles-permissions.enum';
import { HasPermissionDirective } from '@edtech-ui/access-role-permissions/users-permissions-directives/has-permissions.directives';
import { ResumeService } from '@edtech-ui/core/services/resume-service/resume.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';

@Component({
	selector: 'app-resumer-builder-summary',
	standalone: true,
	imports: [ReactiveFormsModule, CommonModule, FormsModule,HasPermissionDirective],
	templateUrl: './resumer-builder-summary.component.html',
	styleUrl: './resumer-builder-summary.component.scss'
})
export class ResumerBuilderSummaryComponent implements OnInit, OnDestroy {

	isGenerated = false;
	isLoading = false;
	summaryText = '';
	resumeId: string = '';
	subscription = new Subscription();
	suggestions: string[] = [];
	PermissionForStudents = PermissionForStudents;


	constructor(
		private resumeService: ResumeService,
		private _toastr: ToastrService,
		private route: ActivatedRoute
	) { }


	ngOnInit(): void {
		const resumeIdFromRoute = this.route.snapshot.paramMap.get('resumeId');

		if (resumeIdFromRoute) {
			this.resumeId = resumeIdFromRoute;
			this.resumeService.setResumeId(this.resumeId);
		} else {
			this.resumeId = this.resumeService.getResumeId();
		}
		const data = this.resumeService.getSectionData('summary');

		if (data) {
			this.editSummaryData(data);
		}
	}


	selectSummary(value: string) {
		this.summaryText = value;
	}


	onInputChange() {
		if (!this.summaryText) {
			this.summaryText = '';
		}
	}


	postAIGeneratedSummary() {
		if (!this.resumeId) {
			this._toastr.error('resume ID is not available');
			return;
		}
		
		this.isLoading = true;

		const payload = {
			resume_id: this.resumeId
		}

		this.subscription.add(
			this.resumeService.postAIGeneratedSummary(payload).pipe(
				tap(response => {
					if (response.Success) {
						this.isGenerated=true;
						this._toastr.success(response.Message);
						this.suggestions = response.Data.summaries;
					}
				}),
				finalize(() => {
					this.isLoading = false;
				}),
				catchError(() => {
					this._toastr.error('Something went wrong');
					return of(null);
				})
			).subscribe()
		)
	}


	saveData() {
		this.resumeService.setSectionData('summary', this.summaryText);
	}


	editSummaryData(data: any) {
		if (!data) return;
		this.summaryText = data || '';
	}


	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}


}